export const userInputs = [
  {
    id: "username",
    label: "Username",
    type: "text",
    placeholder: "john_doe",
  },
  {
    id: "fullname",
    label: "Fullname",
    type: "text",
    placeholder: "John Doe",
  },
  {
    id: "email",
    label: "Email",
    type: "email",
    placeholder: "johndoe@gmail.com",
  },
  {
    id: "password",
    label: "Password",
    type: "password",
  },
  {
    id: "phone",
    label: "Phone",
    type: "text",
    placeholder: "+977 9865 XXX XXX",
  },
  {
    id: "address",
    label: "Address",
    type: "text",
    placeholder: "New Baneswor, Kathmandu",
  },
  {
    id: "country",
    label: "Country",
    type: "text",
    placeholder: "Nepal",
  },
];

export const productInputs = [
  {
    id: 1,
    label: "Title",
    type: "text",
    placeholder: "Acer Nitro 5",
  },
  {
    id: 2,
    label: "Description",
    type: "text",
    placeholder: "Description",
  },
  {
    id: 3,
    label: "Category",
    type: "text",
    placeholder: "Computers",
  },
  {
    id: 4,
    label: "Price",
    type: "text",
    placeholder: "200",
  },
  {
    id: 5,
    label: "Stoc",
    type: "text",
    placeholder: "In Stock",
  },
];
